import m from "../../../../geodata/es2015/region/usa/hiLow";
window.am4geodata_region_usa_hiLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/hiLow.js
// module id = null
// module chunks = 